import api from "@/store/api";

const tag = {
  namespaced: true,
  state: () => ({
    uid: undefined,
    session: undefined,
    data: {},
    status: 0,
  }),
  getters: {
    prefs(state) {
      return !state.data.cliente ? {} : JSON.parse(state.data.cliente.opcoes);
    },
  },
  mutations: {
    setData: (state, payload) => (state.data = payload),
    setUID: (state, payload) => (state.uid = payload),
    setSession: (state, payload) => (state.session = payload),
    setStatus: (state, payload) => (state.status = payload),
  },
  actions: {
    checkIn({ commit }, { uid, callbackSuccess, callbackError }) {
      commit("setStatus", 1);
      const time = setTimeout(() => {
        api
          .post(`/api/tag/checkin?uid=${uid}`)
          .then((result) => {
            commit("setSession", result.data.content);
            callbackSuccess && callbackSuccess(result);
            commit("setStatus", !result.data.content ? 3 : 0);
          })
          .catch((err) => {
            console.error(err);
            callbackError && callbackError(err);
            commit("setStatus", 2);
          });
        clearTimeout(time);
      }, 3000);
    },
  },
};

export default tag;
